import React, { Dispatch, forwardRef, SetStateAction, useContext, useImperativeHandle } from 'react';
import { FormContext } from '../common/form/FormContext';
import { useMutationWithContext } from '../common/hooks/useMutationWithContext';
import { failedToastMessage, successToastMessage } from '../common/utils/commonUtils';
import { QuickAddOrganizationForm } from './QuickAddOrganizationForm';
import { client, saveQuery } from './organization';

type KeyOrganizationEditorProps = {
    id: string;
    setIsSaveDisabled: Dispatch<SetStateAction<boolean>>;
    keyOrganizationFormFields: boolean;
};

export default forwardRef(({ id, setIsSaveDisabled, keyOrganizationFormFields }: KeyOrganizationEditorProps, ref) => {
    const { state, setState } = useContext(FormContext);
    const [save] = useMutationWithContext(saveQuery, client);
    const onOrganizationSave = (onSuccess = undefined, onError = undefined) => {
        const savedEntity = {
            ...state,
            identity: {
                id: ''
            },
            websiteURL: ''
        };
        // The organization does have role field hence removing it before save
        const { isSharedInDirectory, security, organizationRole, name, ...rest } = savedEntity;
        delete savedEntity.reference;
        delete savedEntity.contactLocation;

        save({
            variables: {
                input: { ...rest }
            }
        })
            .then((res) => {
                if (res.data?.autoCreateOrganization?.errors || res.data?.saveOrganization?.errors) {
                    failedToastMessage('form.save.failure', { name: savedEntity?.publicName });
                    onError?.();
                } else {
                    successToastMessage('form.save.success', { name: savedEntity?.publicName });
                    onSuccess?.(savedEntity, res?.data?.saveOrganization?.id);
                }
            })
            .catch((err) => {
                failedToastMessage('form.save.failure', { name: savedEntity?.publicName });
                onError?.();
            });
    };

    useImperativeHandle(ref, () => ({
        handleSave: (onSuccess, onError) => {
            onOrganizationSave(onSuccess, onError);
        }
    }));

    return (
        <QuickAddOrganizationForm
            id={id}
            setIsSaveDisabled={setIsSaveDisabled}
            checkShowLocation={() => false}
            keyOrganizationFormFields={keyOrganizationFormFields}
        />
    );
});
